import http from "../http-common";
import authHeader from "../../services/auth-header";

const userCache = new Map();

export const cacheUserName = (u) => {
  if (!u) return;
  const id = u._id || u.id;
  if (!id) return;
  const fname = u.firstName || u.firstname || u.first_name || u.name || "";
  const lname = u.lastName || u.lastname || u.last_name || "";
  const fullName = (lname ? lname + (fname ? " " : "") : "") + fname;
  if (fullName) {
    userCache.set(String(id), fullName);
  }
};

export const getCachedUserName = (id) => {
  if (!id) return "";
  return userCache.get(String(id)) || "";
};

const getAll = (params) => {
  return http.get("/users" , { headers: authHeader(), params }).then(res => {
    const list = res?.data ?? res ?? [];
    if (Array.isArray(list)) list.forEach(cacheUserName);
    return res;
  });
};

const getGuarantorMembers = (excludeId) => {
  return http.get("/users", {
    headers: authHeader(),
    params: { forGuarantor: true, ...(excludeId ? { excludeId } : {}) }
  }).then(res => {
    const list = res?.data ?? res ?? [];
    if (Array.isArray(list)) list.forEach(cacheUserName);
    return res;
  });
};

const getRefereeMembers = (excludeId) => {
  return http.get("/users", {
    headers: authHeader(),
    params: { forReferee: true, ...(excludeId ? { excludeId } : {}) }
  }).then(res => {
    const list = res?.data ?? res ?? [];
    if (Array.isArray(list)) list.forEach(cacheUserName);
    return res;
  });
};

const adminGetAll = () => {
  return http.get("/adminperm", { headers: authHeader() }).then(res => {
    const list = res?.data ?? res ?? [];
    if (Array.isArray(list)) list.forEach(cacheUserName);
    return res;
  });
};

const presGetAll = () => {
  return http.get("/presidentperm", { headers: authHeader() }).then(res => {
    const list = res?.data ?? res ?? [];
    if (Array.isArray(list)) list.forEach(cacheUserName);
    return res;
  });
};

const get = (id) => {
  return http.get(`/adminperm/${id}` , { headers: authHeader() }).then(res => {
    const u = res?.data ?? res ?? {};
    cacheUserName(u);
    return res;
  });
};

const remove = (id) => {
  return http.delete(`/adminperm/${id}` , { headers: authHeader() });
};

/*const findByTitle = (title) => {
  return http.get(`/tutorials?title=${title}`);
}; */

const update = (id, data) => {
  return http.patch(`/adminperm/${id}`, data, { headers: authHeader() });
};

const getSummary = () => {
  return http.get("/summary", { headers: authHeader() });
};

const getFinancialOfficers = () => {
  return http.get("/financial/officers", { headers: authHeader() });
};

const allocateMembers = (data) => {
  return http.post("/financial/allocate", data, { headers: authHeader() });
};

const getActivityLogs = (params) => {
  return http.get("/activity-logs", { headers: authHeader(), params });
};

const logActivity = (data) => {
  return http.post("/activity-logs", data, { headers: authHeader() });
};

const getDashboardTotals = () => {
  return http.get("/dashboard/totals", { headers: authHeader() });
};

const recordBroughtForward = (data) => {
  return http.post("/financial/brought-forward", data, { headers: authHeader() });
};

const recordBulkBroughtForward = (data) => {
  return http.post("/financial/brought-forward/bulk", data, { headers: authHeader() });
};

const UserService = {
  getAll,
  getGuarantorMembers,
  getRefereeMembers,
  adminGetAll,
  presGetAll,
  getSummary,
  getFinancialOfficers,
  allocateMembers,
  recordBroughtForward,
  recordBulkBroughtForward,
  getActivityLogs,
  logActivity,
  getDashboardTotals,
  get,
  update,
  remove,
  getCachedUserName,
  cacheUserName
};

export default UserService;
